import React from "react";
import { Modal, Tooltip } from "antd";
import { EditOutlined, DownloadOutlined } from "@ant-design/icons";

const ViewGRNForm = ({
  visible,
  setVisible,
  grn,
  grnFile,
  orderId,
  handleGRNFileDownload,
  setEditGRNModal,
}) => {
  const handleCancel = () => {
    setVisible(false);
  };
  const handleEdit = () => {
    setVisible(false);
    setEditGRNModal(true);
  };

  return (
    <Modal
      title={`GRN Details for order ${orderId}`}
      visible={visible}
      onCancel={handleCancel}
      onOk={handleEdit}
      okText="Edit GRN"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <p>GRN Number : {grn}</p>
        </div>
        <div style={{ display: "flex", color: "#0a8080", fontSize: "20px" }}>
          <p style={{ marginLeft: "5px", cursor: "pointer" }}>
            <Tooltip title="Edit GRN Details">
              <EditOutlined onClick={handleEdit} />
            </Tooltip>
          </p>
          <p style={{ marginLeft: "15px", cursor: "pointer" }}>
            <Tooltip title="Download GRN File">
              <DownloadOutlined onClick={handleGRNFileDownload} />
            </Tooltip>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ViewGRNForm;
